import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteOmsPriorityFilter = {
  name: "deleteOmsPriorityFilter" as const,
  input: z.object({ id: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
